module.exports = __webpack_public_path__ + "img/tiago.81eed57e.jpeg";